"use client";
import { Link } from "components/shared/Link";
import Image from "next/legacy/image";
import { Container } from "components/layout/Container";
import s from "./Footer.module.scss";
import st from "@/styles/modules/typography.module.scss";
import { SpriteIcon } from "components/UI/SpriteIcon";
import locationIcon from "/public/img/icons/location.svg";
import cn from "classnames";
import { getFooterLinks } from "@/components/layout/footer/getFooterLinks";
import { useAppSelector } from "@/store";
import { isWritingServiceSelector } from "@/store/global/globalSlice";
import { usePathname } from "next/navigation";
import { baseUrl } from "@/const";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import FacebookIcon from "public/img/icon-facebook.svg";
import TwitterIcon from "public/img/icon-twitter.svg";
import { useInteraction } from "@/lib/priceCalculator/helpers/useInteraction";

const content = {
  title: "This service will come in handy for:",
  description:
    "Students in need of free samples of academic papers such as essays, book reports, research papers, term papers on various different topics. To gain a more in depth understanding of a particular topic or subject. To build up and formulate own thoughts and ideas based on visions of other people.",
};

export const Footer = () => {
  const { title, description } = content;
  const isWritingService = useAppSelector(isWritingServiceSelector);

  const { isInteracted } = useInteraction();

  const links = getFooterLinks(isWritingService);

  const pathname = usePathname();

  return (
    <footer className={s.footer}>
      <Container className={s.container}>
        <div className={s.footerInner}>
          <div className={s.footerLeft}>
            <div className={s.footerLogo}>
              <Image src="/img/logo.svg" alt="StudyBounty" width={187} height={45} />
            </div>

            <div className={s.footerAddress}>
              <SpriteIcon icon={locationIcon} />
              <Image src="/img/address.svg" width={222} height={35} alt="address" />
            </div>

            <div className={s.footerText}>
              <p className={cn(st.headingH4, s.footerTitle)}>{title}</p>
              <p className={s.footerDescription}>{description}</p>
              <div className={s.footerSharing}>
                <FacebookShareButton url={`https://${baseUrl + pathname}`}>
                  <FacebookIcon />
                </FacebookShareButton>
                <TwitterShareButton url={`https://${baseUrl + pathname}`}>
                  <TwitterIcon />
                </TwitterShareButton>
              </div>
            </div>
          </div>
          <div className={s.footerRight}>
            {links.map((item) => (
              <div key={item.name} className={s.footerLinksCol}>
                <p className={s.footerLinksColName}>{item.name}</p>
                <ul className={s.footerLinksGroup}>
                  {item.links.map(({ name, href, includeSubdomain }) => (
                    <li key={href}>
                      <Link
                        href={href}
                        includeSubdomain={includeSubdomain}
                        className={cn(st.link, {
                          [st.linkActive]: href === pathname,
                        })}
                      >
                        {name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className={s.footerBottom}>
          <small className={s.footerCopy}>
            &copy;{" "}
            <Link href="/" includeSubdomain>
              StudyBounty.com
            </Link>{" "}
            {new Date().getFullYear()}. All right reserved.
          </small>

          <div className={s.bottomIcons}>
            <a
              href={`https://www.dmca.com/Protection/Status.aspx?ID=139cd0aa-f936-4876-8283-3177983f947c&refurl=https://${
                baseUrl + (pathname.length > 1 ? pathname : "")
              }`}
              title="DMCA.com Protection Status"
              target="_blank"
              rel="noreferrer nofollow"
            >
              <Image src="/img/payments/dmca.svg" alt="dmca" width={61} height={20} />

              {isInteracted && (
                <img
                  style={{ display: "none" }}
                  src="https://images.dmca.com/Badges/dmca_copyright_protected150a.png?ID=139cd0aa-f936-4876-8283-3177983f947c"
                  alt="DMCA.com Protection Status"
                />
              )}
            </a>

            <Image src="/img/payments/trusted.svg" alt="TrustedSite" width={92} height={19} />
          </div>
        </div>
      </Container>
    </footer>
  );
};
